var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    { staticStyle: { height: "100vh" }, attrs: { direction: "vertical" } },
    [
      _c("el-main", [
        _c(
          "div",
          { staticClass: "registration" },
          [
            _c(
              "div",
              { staticClass: "options" },
              [
                _vm.isVerifiedToken
                  ? [
                      _c("p", { staticClass: "dear" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("registration.dear", { name: _vm.form.name })
                          )
                        ),
                      ]),
                    ]
                  : _vm._e(),
                _c(
                  "el-select",
                  {
                    attrs: { size: "mini" },
                    on: { change: _vm.setLocaleSetting },
                    model: {
                      value: _vm.$i18n.locale,
                      callback: function ($$v) {
                        _vm.$set(_vm.$i18n, "locale", $$v)
                      },
                      expression: "$i18n.locale",
                    },
                  },
                  _vm._l(_vm.languages, function (lang, index) {
                    return _c("el-option", {
                      key: index,
                      attrs: { value: lang.code, label: lang.label },
                    })
                  }),
                  1
                ),
              ],
              2
            ),
            _c("div", { staticClass: "logo" }, [
              _c("img", { attrs: { src: _vm.images.logo } }),
            ]),
            _c("h1", [_vm._v(_vm._s(_vm.$t("registration.title01")))]),
            _vm.isVerifiedToken
              ? [
                  _c("p", { staticClass: "description" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("registration.description01", {
                          owner: _vm.form.manager_name,
                          role: _vm.form.role,
                        })
                      )
                    ),
                  ]),
                  _c(
                    "el-form",
                    {
                      ref: "form",
                      attrs: { "label-width": "150px", model: _vm.form },
                    },
                    [
                      _c("p", { staticClass: "item" }, [
                        _vm._v(_vm._s(_vm.$t("registration.name"))),
                      ]),
                      _c("p", { staticClass: "border" }, [
                        _vm._v(_vm._s(_vm.form.name)),
                      ]),
                      _c("p", { staticClass: "item" }, [
                        _vm._v(_vm._s(_vm.$t("registration.email"))),
                      ]),
                      _c("p", { staticClass: "border" }, [
                        _vm._v(_vm._s(_vm.managerEmail)),
                      ]),
                      _c("p", { staticClass: "item" }, [
                        _vm._v(_vm._s(_vm.$t("registration.password"))),
                      ]),
                      _c(
                        "p",
                        { staticClass: "border" },
                        [
                          _c("el-input", {
                            staticClass: "password",
                            attrs: {
                              type: "password",
                              placeholder: _vm.$t(
                                "registration.password_placeholder"
                              ),
                            },
                            model: {
                              value: _vm.form.password,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "password", $$v)
                              },
                              expression: "form.password",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("p", { staticClass: "item" }, [
                        _vm._v(
                          _vm._s(_vm.$t("registration.password_confirmation"))
                        ),
                      ]),
                      _c(
                        "p",
                        { staticClass: "border" },
                        [
                          _c("el-input", {
                            staticClass: "password",
                            attrs: {
                              type: "password",
                              placeholder: _vm.$t(
                                "registration.password_placeholder"
                              ),
                            },
                            model: {
                              value: _vm.form.password_confirmation,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "password_confirmation", $$v)
                              },
                              expression: "form.password_confirmation",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "send" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.createManager },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("registration.registration"))
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              : [
                  _c("p", { staticClass: "description" }),
                  _c("h1", [_vm._v(_vm._s(_vm.$t("registration.title02")))]),
                  _c("p", { staticClass: "description" }, [
                    _vm._v(_vm._s(_vm.$t("registration.illegal"))),
                  ]),
                ],
          ],
          2
        ),
      ]),
      _c("publicFooter"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }